import React from 'react';
import { Formik, Form } from 'formik';

import { FormElement } from '@dashboard/components/Form';
import { Textarea } from '@dashboard/components/Formik';

import FormSubmit from '@dashboard/components/Formik/components/FormSubmit';
import { transformApiErrorToFormik } from '@dashboard/services/form';
import { isEmpty } from 'lodash';
import FormError from '@dashboard/components/Formik/components/FormError';
import usePage from '@dashboard/hooks/usePage';

const CustomCSSForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Formik
      initialValues={{ customCss: page.customCss }}
      onSubmit={async (values, actions) => {
        actions.setStatus(undefined);

        const { data, error } = await updatePage.mutateAsync(values);

        if (data) {
          actions.setStatus('');
          actions.resetForm({
            values: {
              customCss: data.customCss,
            },
          });
        } else {
          const { status, errors } = transformApiErrorToFormik(error);

          if (!isEmpty(errors)) {
            actions.setErrors(errors);
          } else {
            actions.setStatus(status);
          }
        }
      }}
    >
      {({ status, dirty, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <FormElement>
            <Textarea
              id="customCss"
              name="customCss"
              placeholder="Custom CSS"
              minRows={10}
              autosize
            />
            <FormError name="customCss" />
          </FormElement>

          <FormElement>{status && status}</FormElement>

          <FormSubmit>
            <FormSubmit.Button>Save</FormSubmit.Button>
            <FormSubmit.State visible={!!dirty} />
          </FormSubmit>
        </Form>
      )}
    </Formik>
  );
};

export default CustomCSSForm;
